import { render } from "./WorkgroupTableComponent.vue?vue&type=template&id=0e1629a6"
import script from "./WorkgroupTableComponent.vue?vue&type=script&lang=js"
export * from "./WorkgroupTableComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\c.a.defilippis\\source\\repos\\Ticketing\\B24TicketingFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__